import { FC } from 'react';

import { PhoneListProps } from './PhoneList.props';

import cn from 'classnames';
import { removePhoneNonNumericCharacter } from '@/utils/removePhoneNonNumericCharacter';

export const PhoneList: FC<PhoneListProps> = ({ data, listClassName }) => {
  return (
    <ul className={cn(listClassName)}>
      {data.map(link => (
        <li key={link.item}>
          <a
            className="overflow-wrap break-words py-3 transition-colors duration-300 hover:text-accentMain focus:text-accentMain"
            href={`tel:${removePhoneNonNumericCharacter(link.item)}`}
          >
            {link.item}
          </a>
        </li>
      ))}
    </ul>
  );
};
